export default "__VITE_ASSET__3e8ff4a3__"